import { request } from '@/shared/api/request'
export const downloadSSPData = (period, bin) =>
	request({
		url: '/contract/universalMethods/downloadSSPData?bin=' + bin + '&period=' + period,
		method: 'GET',
		responseType: 'blob',
	})
